import { useTranslation } from 'react-i18next';
import { Layout } from '@/components/layout/Layout';
import { HeroSection } from '@/components/home/HeroSection';
import { ValueProposition } from '@/components/home/ValueProposition';
import { CollectionsOverview } from '@/components/home/CollectionsOverview';
import { BestsellersSection } from '@/components/home/BestsellersSection';
import { ReviewsSection } from '@/components/home/ReviewsSection';
import { AboutPreview } from '@/components/home/AboutPreview';
import { SocialSection } from '@/components/home/SocialSection';
import { BlogPreview } from '@/components/home/BlogPreview';
import { PageSeoHead } from '@/components/seo/PageSeoHead';
import { StructuredData } from '@/components/seo/StructuredData';

const Index = () => {
  const { i18n } = useTranslation();
  const isIT = i18n.language !== 'en';

  const title = isIT
    ? 'Sampaoli Creazioni – Gioielli in Bronzo per Cacciatori, Climber e Cavalieri'
    : 'Sampaoli Creazioni – Handmade Bronze Jewelry for Hunters, Climbers & Riders';

  const description = isIT
    ? 'Gioielli artigianali in bronzo ispirati a fauna alpina, alpinismo e mondo equestre. Fatti a mano nei Colli Euganei, ipoallergenici e perfetti come regalo.'
    : 'Handcrafted bronze jewelry inspired by alpine wildlife, climbing and equestrian culture. Made by hand in Italy — hypoallergenic and the perfect outdoor gift.';

  return (
    <Layout>
      <PageSeoHead title={title} description={description} path="/" />
      <StructuredData type="organization" />
      <StructuredData type="website" />
      <StructuredData type="localBusiness" />
      <HeroSection />
      <CollectionsOverview />
      <BestsellersSection />
      <ReviewsSection />
      <ValueProposition />
      <BlogPreview />
      <AboutPreview />
      <SocialSection />
    </Layout>
  );
};

export default Index;
